var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import { createSelector } from 'reselect';
import { fetchOwnedCollections } from '../../api/collections';
import { createReducer } from '../../reducers/factory';
import { EOwnedCollectionStatus, } from './types';
import { HIDE_COLLECTION, ownedCollectionsSliceName, REMOVE_CARDS_FROM_COLLECTIONS, } from './utils';
import { fetchCountryIfNeeded } from '../../actions/CountryActions';
import { MINUTE_MS, SECOND_MS } from '../../time';
import { isEmptyObject } from '../../utils/records';
import useFetchSelector from '../../hooks/useFetchSelector';
var name = ownedCollectionsSliceName;
var UPDATE_OWNED_COLLECTION_AFTER_SAVE = 'UPDATE_OWNED_COLLECTION_AFTER_SAVE';
var withCardsRemoved = function (state, cardIds) { return (__assign(__assign({}, state), { items: state.items.map(function (ownedCollectionItem) { return (__assign(__assign({}, ownedCollectionItem), { slots: ownedCollectionItem.slots.filter(function (slot) {
            return isEmptyObject(slot) || !slot.card || !cardIds.includes(slot.card);
        }) })); }) })); };
var ownedCollectionsReducer = createReducer('CARDS_COLLECTIONS_OWNED', {
    fetchTimeout: 30 * SECOND_MS,
    invalidateActions: ['SET_LANGUAGE', 'LOGIN_SUCCESSFUL'],
    resetActions: ['LOGOUT_SUCCESSFUL'],
    extendedReducer: (_a = {
            SHRED_CARD_SUCCESSFUL: function (state, action) {
                return action.cardId ? withCardsRemoved(state, [action.cardId]) : state;
            },
            SHRED_CARDS_SUCCESSFUL: function (state, action) { var _a; return withCardsRemoved(state, (_a = action === null || action === void 0 ? void 0 : action.cardIds) !== null && _a !== void 0 ? _a : []); }
        },
        _a[REMOVE_CARDS_FROM_COLLECTIONS] = function (state, action) { var _a; return withCardsRemoved(state, (_a = action.cardsIds) !== null && _a !== void 0 ? _a : []); },
        _a[HIDE_COLLECTION] = function (state, action) {
            var isProgressItemPresent = state.items.some(function (item) { return item.collectionCampaign._id === action.collectionId; });
            if (!isProgressItemPresent && !action.collection) {
                return state;
            }
            var newItems = isProgressItemPresent
                ? state.items.map(function (item) {
                    return item.collectionCampaign._id === action.collectionId
                        ? __assign(__assign({}, item), { hidden: true }) : item;
                })
                : __spreadArray(__spreadArray([], state.items, true), [
                    {
                        _id: action.collectionId,
                        collectionCampaign: action.collection,
                        hidden: true,
                        // Status and slots are not relevant here. We only need the `hidden` flag to imitate how
                        // it would be returned from the backend, so that we can filter it out from the carousel.
                        status: EOwnedCollectionStatus.IN_PROGRESS,
                        slots: [],
                    },
                ], false);
            return __assign(__assign({}, state), { items: newItems });
        },
        _a[UPDATE_OWNED_COLLECTION_AFTER_SAVE] = function (state, action) {
            var isProgressItemPresent = state.items.some(function (item) { return item.collectionCampaign._id === action.collection._id; });
            return __assign(__assign({}, state), { items: isProgressItemPresent
                    ? state.items.map(function (item) {
                        return item.collectionCampaign._id === action.collection._id
                            ? __assign(__assign({}, item), { collectionCampaign: action.collection, slots: action.slots, status: action.status }) : item;
                    })
                    : __spreadArray(__spreadArray([], state.items, true), [
                        {
                            hidden: false,
                            _id: action.progressId,
                            collectionCampaign: action.collection,
                            status: action.status,
                            slots: action.slots,
                        },
                    ], false) });
        },
        _a),
    minUpdate: 2 * MINUTE_MS,
    initialItems: [],
});
export var ownedCollectionsPlainSelector = function (_a) {
    var _b = name, cardsCollectionsCompleted = _a[_b];
    return cardsCollectionsCompleted;
};
var fetchOwnedCollectionsAction = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var fetchPromise;
    return __generator(this, function (_a) {
        fetchPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
            var state, _a, apiUrl, token, country, res, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        state = getState();
                        _a = state.auth, apiUrl = _a.apiUrl, token = _a.token;
                        if (!token) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, dispatch(fetchCountryIfNeeded())];
                    case 1:
                        country = _b.sent();
                        return [4 /*yield*/, fetchOwnedCollections(apiUrl, token, country)];
                    case 2:
                        res = _b.sent();
                        dispatch(ownedCollectionsReducer.fetchSuccessful(res));
                        return [2 /*return*/, res];
                    case 3:
                        e_1 = _b.sent();
                        dispatch(ownedCollectionsReducer.fetchFailed(e_1));
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        dispatch(ownedCollectionsReducer.fetchInProgress(fetchPromise));
        return [2 /*return*/, fetchPromise];
    });
}); }; };
export var ownedCollectionsSelector = createSelector(ownedCollectionsPlainSelector, function (_a) {
    var fetchingInProgressSince = _a.fetchingInProgressSince, lastSuccessfulFetch = _a.lastSuccessfulFetch, lastFailedFetch = _a.lastFailedFetch, rest = __rest(_a, ["fetchingInProgressSince", "lastSuccessfulFetch", "lastFailedFetch"]);
    return (__assign(__assign({}, rest), { loading: !!fetchingInProgressSince || (!lastSuccessfulFetch && !lastFailedFetch) }));
});
export var fetchOwnedCollectionsIfNeeded = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var sliceState, fetchPromise, items;
    var _a;
    return __generator(this, function (_b) {
        sliceState = ownedCollectionsPlainSelector(getState());
        if (((_a = getState().auth) === null || _a === void 0 ? void 0 : _a.token) &&
            ownedCollectionsReducer.shouldFetch(sliceState)) {
            return [2 /*return*/, dispatch(fetchOwnedCollectionsAction())];
        }
        fetchPromise = sliceState.fetchPromise, items = sliceState.items;
        return [2 /*return*/, typeof (fetchPromise === null || fetchPromise === void 0 ? void 0 : fetchPromise.then) === 'function' ? fetchPromise : items];
    });
}); }; };
export var updateOwnedCollection = function (collection, status, slots, progressId) { return ({
    type: UPDATE_OWNED_COLLECTION_AFTER_SAVE,
    collection: collection,
    status: status,
    slots: slots,
    progressId: progressId,
}); };
export var useOwnedCollections = function () {
    return useFetchSelector(fetchOwnedCollectionsIfNeeded, ownedCollectionsPlainSelector);
};
export var useCompletedCollection = function (idOrAlias) {
    var ownedCollections = useOwnedCollections().items;
    return ownedCollections === null || ownedCollections === void 0 ? void 0 : ownedCollections.find(function (collection) {
        return collection.status === 'completed' &&
            (collection.collectionCampaign._id === idOrAlias ||
                collection.collectionCampaign.urlAlias === idOrAlias);
    });
};
function OwnedCollectionsReducer(state, action) {
    if (state === void 0) { state = ownedCollectionsReducer.INITIAL_STATE; }
    if (action === void 0) { action = { type: undefined }; }
    return ownedCollectionsReducer(state, action);
}
export default (_b = {}, _b[name] = OwnedCollectionsReducer, _b);
